import { faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useNotification from 'hooks/useNotification';
import { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import KbGroupsService from 'services/KbGroups.service';
import KbGroupDeletionModal from './KbGroupDeletionModal';

const KbGroupEditModal = ({ showModal, handleClose, refresh, groupToEdit }) => {
  const [validated, setValidated] = useState(false);
  const [showDeletionModal, setShowDeletionModal] = useState(false);
  const [groupId, setGroupId] = useState(null);
  const [groupName, setGroupName] = useState('');
  const [body, setBody] = useState({
    name: '',
    description: ''
  });
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const form = useRef(null);

  // Efeito para preencher o formulário quando está editando
  useEffect(() => {
    if (showModal) {
      if (groupToEdit) {
        // Preencher o formulário com os dados da categoria a ser editada
        setBody({
          name: groupToEdit.name,
          description: groupToEdit.description || ''
        });

        setGroupId(groupToEdit.id);
        setGroupName(groupToEdit.name);
      }
      setValidated(false);
    }
  }, [showModal, groupToEdit]);

  const clearFields = () => {
    setBody({
      name: '',
      description: ''
    });
  };

  const onSubmit = async e => {
    e.preventDefault();

    if (form.current.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    // Cria ou edita
    const response = await KbGroupsService.update(groupToEdit.id, body);

    if (response.userMessage) {
      showErrorNotification(response.userMessage);
      return;
    }

    showSuccessNotification('Grupo atualizado com sucesso');

    refresh();
    handleClose();
    clearFields();
  };

  return (
    <>
      <KbGroupDeletionModal
        show={showDeletionModal}
        close={() => setShowDeletionModal(false)}
        isSuccess={refresh}
        groupId={groupId}
        groupName={groupName}
      />
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{'Editar Grupo'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form validated={validated} ref={form}>
            <Form.Group className="mb-3">
              <Form.Label>
                Nome <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Inserir nome do grupo"
                autoFocus
                value={body.name}
                onChange={e =>
                  setBody(prevState => ({ ...prevState, name: e.target.value }))
                }
              />
              <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Insira um nome.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="(opcional)"
                value={body.description}
                onChange={e =>
                  setBody(prevState => ({
                    ...prevState,
                    description: e.target.value
                  }))
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className={`d-flex justify-content-between`}>
          <Col xs="auto">
            <Button
              className="text-danger"
              variant="falcon-default"
              onClick={() => {
                setShowDeletionModal(true);
                handleClose();
              }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </Col>
          <Row xs="auto">
            <Button variant="falcon-default" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={onSubmit} className="ms-2">
              <FontAwesomeIcon icon={faSave} className="me-2" />
              Salvar
            </Button>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default KbGroupEditModal;
